import { ReactNode } from "react";
import { Stack, SxProps, Theme } from "@mui/material";

type Props = {
  children: ReactNode;
  layoutStyles?: SxProps<Theme>;
  containerStyles?: SxProps<Theme>;
};

const PageLayout = ({
  children,
  layoutStyles,
  containerStyles,
}: Props) => {
  return (
    <Stack
      sx={[
        {
          width: "100%",
          gap: 3,
        },
        ...(Array.isArray(layoutStyles) ? layoutStyles : [layoutStyles]),
        ...(Array.isArray(containerStyles)
          ? containerStyles
          : [containerStyles]),
      ]}
    >
      {children}
    </Stack>
  );
};

export default PageLayout;
